import { retrieveErrorFromApi } from '../../../../helper'
import { setAppErrors } from '../../../action/system'
import printRequest from '../../../axios/order/printRequest'
import { selectUsername } from '../../../selector/system'

export const printRequestsThunk = (orderId, layoutType, canceledPrint = null, processedBy = null) => (dispatch, getState) => {
	const systemUsername = selectUsername(getState())
	const requestedByUsername = processedBy ? processedBy : systemUsername
	const data = { orderId, layoutType, canceledPrint, printerMetaData: { userPrintRequest: { userName: requestedByUsername } } }
	return printRequest(data)
		.then(res => {
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
